module.exports = {"id":"200155","name":"Hans Vanaken","rating":"77","photo":"./data/images/photos/3/200155.png","club":{"name":"Club Bruges","logo":"./data/images/clubs/ClubBruges.png"},"positions":["MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HansVanaken0.json
// module id = 1692
// module chunks = 0